<template>
	<div v-show="isModalVisible">
	  <div class="modal-mask" @click="closeModal">
  		<div class="modal-container" @click.stop>
      		<!-- Modal Header -->
      		<div class="modal-header">
        	<h6 class="modal-title"><b>Course Details</b></h6>
        	<button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      		</div>
      		<!-- Modal body -->
      		<div class="modal-body" >

            <div class="row account_view_list_heading_row col-12">
               <div class="first_name_field heading">First</div>
               <div class="last_name_field heading">Last</div>
               <div class="email_field heading">Email</div>
               <div class="assessment_name_field heading">Course Name</div>
               <div class="assigned_field heading">Assigned</div>
               <div class="attempt_field heading">Last Attempt</div>
               <div class="time_field heading">Time in Course</div>
               <div class="score_field heading">Score</div>
               <div class="certificate_field heading" style="text-align: center;">Certificate</div>
            </div>

            <div class="row account_view_list_row col-12">
               <div class="first_name_field text">{{ menteeFirstName }}</div>
               <div class="last_name_field text">{{ menteeLastName }}</div>
               <div class="email_field text">{{ menteeEmail }}</div>
               <div class="assessment_name_field text">{{ courseTitle }}</div>
               <div class="assigned_field text">{{ assignedDate | format1Date }}</div>
               <div class="attempt_field text">{{ completedOn }}</div>
               <div class="time_field text" style="text-align: center;">{{ timeSpent }}</div>
               <div class="score_field text" style="text-align: cener;">{{ score }}%</div>
               <div class="certificate_field text view-certificate" @click="viewReport(cert)">View</div>
            </div>



        		<div style="clear: both; margin-bottom: 20px;"></div>
        		<div class="col-12 p-0" style="margin: 0 auto;">

            <div
              class="course-title">
              <a href="javascript:void(0);" @click="showModules" class="reps_history">
              <i :class="toggleFontIcon" style="font-size: 20px;"></i>
              </a>



            </div>
            <div style="clear: both; margin-bottom: 20px;"></div>
            <ModuleDetails 
              :courseModules="courses_modules"
              ref="reps_history"
            >
            </ModuleDetails>




        		</div>

            </div>
            <div class="modal-footer" >
              <div class="col-12 text-center view-certificate" style="font-size: 13px;" @click="closeModal">
                <b>Close</b>
              </div>
            </div>

        </div>
      </div>

	</div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import { store } from '../../store/store';
import moment from 'moment';
import ModuleDetails from './course_module_details';



Vue.filter('format1Date', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
    props: [
    	'isModalVisible',
    	'courseId',
    	'menteeId',
    ],
    data: function () {
        return {
        	courses_modules: [],
        	menteeFirstName: '',
        	menteeLastName: '',
        	menteeEmail: '',
        	courseTitle: '',
        	assignedDate: '',
          completedOn: '',
          score: '',
          timeSpent: '',
          cert: '',
          visible: false,
          index: 99999,
          toggleFontIcon: 'fa fa-angle-down',
          isToggledCourseModal: false,

        }
    },        
    methods: {
      showModules() {
        this.$refs.reps_history.fetchRepsHistory();
      },
    	viewReport: function(url) {
          window.open(url, '_blank');
    	},
	    closeModal() {
	        this.menteeFirstName = '';
	        this.menteeLastName = '';
	        this.menteeEmail = '';
          this.courseTitle = '';
          this.assignedDate = '';
          this.completedOn = '';
          this.score = '';
          this.timeSpent = '';
          this.cert = '';
          this.courses_modules = [];
          this.$refs.reps_history.hideRepsHistory();

	        this.$emit('close');
	    },
	    getUserCourseDetails: function(courseId, menteeId) {
        axios.get('/desktop/get-user-course-details', {
          params: {
            mentee_id: menteeId,
            accountId: this.$store.state.user_accountid,
            course_id: courseId,
          }
        })
        .then(response =>  {
          console.log(response);
          this.menteeFirstName = response.data.mentee_first_name;
          this.menteeLastName = response.data.mentee_last_name;
          this.menteeEmail = response.data.mentee_email;
          this.courseTitle = response.data.course_title;
          this.assignedDate = response.data.assigned_date;
          this.completedOn = response.data.completedOn;
          this.score = response.data.score;
          this.timeSpent = response.data.timeSpent;
          this.cert = response.data.cert_link;
          this.courses_modules = response.data.modules;
        })
        .catch(() => {

        });


	    },
    },
    components: {
      ModuleDetails,
    },
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 1160px;
    height: 500px;
    overflow-y: scroll;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    color: #002F42;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 98%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
  }
}

.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.btn-info, .btn-info:hover, .btn-info:focus {
  background-color: #C3C3C3 !important;
  border: 1px solid #CCC !important;
  color: #000;
}
.btn {
  padding: 1px 0px;
}
.account_view_list_heading_row {
	background-color: #29A3E4;
	padding: 3px 10px;
}
.account_view_list_row { 
	width: 100%;
	padding: 5px 10px;
}
.heading {
	color: #FFF;
	font-size: 14px;
}
.title_text {
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  margin-bottom: 10px;
  margin-left: 15px;
}
.text {
	color: #002F42;
	font-size: 13px;
	font-weight: bold;
}
.first_name_field, .last_name_field, .assigned_field, .attempt_field, .time_field {
	width: 10%;
	float: left;
}
.score_field {
  width: 5%;
  float: left;
}
.certificate_field {
  width: 6%;
  float: left;
}
.email_field {
	width: 22%;
	float: left;
}
.assessment_name_field {
	width: 17%;
	float:left;
}
.view-certificate {
    text-align: center;
    font-size: 11px;
    color: #29A3E4;
    cursor: pointer;
    text-decoration: underline !important;
	
}
.course-title {
  float: right;
  text-align: right;
  cursor: pointer;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.course-title i {
  float: right;
  padding-right: 15px;
  font-weight: normal;
  font-size: 12px;
  color: #29A3E4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/UserCourseDetailsModal.vue